import React from "react";
import StatsGrid from "../../../../../components/reusable/management/StatsGrid";
// import "../../../../../css/pages/ca_pages/teams/teams_model/DashboardOverviewCards.css";

const ActivityStatsCards = ({ stats }) => {
    const cards = [
        {
            title: "Today's Activities",
            value: stats?.todayActivities ?? 0,
            subtitle: "Activity records created today",
            color: "#2563eb",
            icon: "👥",
        },
        {
            title: "Tasks Completed",
            value: stats?.tasksCompleted ?? 0,
            subtitle: "Completed today",
            color: "#16a34a",
            icon: "🟢",
        },
        {
            title: "Documents Uploaded",
            value: stats?.documentsUploaded ?? 0,
            subtitle: "Document upload activity",
            color: "#ea580c",
            icon: "📋",
        },
        {
            title: "Assignments",
            value: stats?.assignments ?? 0,
            subtitle: "Assignment activity today",
            color: "#7c3aed",
            icon: "✅",
        },
    ];

    return (
        // <div className="overview-grid">
        //     {cards.map((card) => (
        //         <div
        //             key={card.title}
        //             className="overview-card"
        //         >
        //             <div className="overview-card-top">

        //                 <div
        //                     className="overview-icon"
        //                     style={{
        //                         background: `${card.color}15`,
        //                         color: card.color,
        //                     }}
        //                 >
        //                     {card.icon}
        //                 </div>

        //                 <div
        //                     className="overview-value"
        //                     style={{
        //                         color: card.color,
        //                     }}
        //                 >
        //                     {card.value}
        //                 </div>

        //             </div>

        //             <div className="overview-title">
        //                 {card.title}
        //             </div>

        //             <div className="overview-subtitle">
        //                 {card.subtitle}
        //             </div>
        //         </div>
        //     ))}
        // </div>
        <StatsGrid cards = { cards } />
    );
};

export default ActivityStatsCards;
